import React, { Component, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import styles from '../styles.scss'
import { Box, Flex } from 'reflexbox'

class CancelPage extends Component {
  cancelRender = () => {
    return (
      <Flex
      align='center'
      column
      auto
      styleName='flexContainer'
      >
        <p>
            Are you sure you want to delete all current changes?
        </p>
        <Box auto/>
      </Flex>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.cancelRender()}
      </React.Fragment>
    )
  }
}

export default CSSModules(CancelPage, styles)
